import { FaChalkboardTeacher, FaUserGraduate } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import styles from "./styles.module.css";

type Props = {
    onUserRoleSelection: (role: "teacher" | "student") => void;
    isForWarrantyOnboarding?: boolean;
}

export default function UserRole({ onUserRoleSelection, isForWarrantyOnboarding }: Props) {
    const { t } = useTranslation();

    const handleUserRoleSelection = (role: "teacher" | "student") => {
        onUserRoleSelection(role);
    };

    return (
        <div className={styles.userSelectorContainer}>
            <h3>{t('user_role.title')}</h3>
            <div className={styles.userSelector}>
                <button
                    className={styles.userSelectorButton}
                    onClick={() => handleUserRoleSelection("teacher")}
                >
                    <FaChalkboardTeacher />
                    <h4>{t('user_role.teacher')}</h4>
                    <p>{isForWarrantyOnboarding ? t('user_role.teacher_desc') : ""}</p>
                </button>
                <button
                    className={styles.userSelectorButton}
                    onClick={() => handleUserRoleSelection("student")}
                >
                    <FaUserGraduate />
                    <h4>{t('user_role.student')}</h4>
                    <p>{isForWarrantyOnboarding ? t('user_role.student_desc') : ""}</p>
                </button>
            </div>
        </div>)
}
